export default "__VITE_ASSET__9DCsqkGo__"